import * as Sentry from '@sentry/react'

export function initSentry(): void {
	const dsn = import.meta.env.VITE_SENTRY_DSN

	if (!dsn) {
		console.warn('Sentry DSN not configured, error tracking disabled')
		return
	}

	Sentry.init({
		dsn,
		environment:
			import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
		release: import.meta.env.VITE_SENTRY_RELEASE,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		tracesSampleRate: 0.1,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	})
}

export { Sentry }
